import { render, staticRenderFns } from "./AdminProducts.vue?vue&type=template&id=00673c36&scoped=true"
import script from "./AdminProducts.vue?vue&type=script&lang=js"
export * from "./AdminProducts.vue?vue&type=script&lang=js"
import style0 from "./AdminProducts.vue?vue&type=style&index=0&id=00673c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00673c36",
  null
  
)

export default component.exports